import { LegacyOttTrailerPlayerBaseInfoContent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { ProfileManager } from '@/shared/lib/profileManager';
import { Source, Stream } from '@/scenarios/legacy-player/types/config';

import { getEmptyPreferredTracks } from '../../feature-player/utils/config/get-empty-preferred-tracks';
import { getPuidAndFrom } from '../../feature-player/utils/config/get-puid-and-from';
import { TelemetryContentPlace, TelemetryContentType } from '../../Player';

import { getPromoContentId } from './get-promo-content-id';

interface Props {
    telemetryContentPlace: TelemetryContentPlace;
    telemetryContentType: TelemetryContentType;
}

interface Dependencies {
    profileManager: ProfileManager;
}

export const getPromoPlayerConfig = (
    trailer: LegacyOttTrailerPlayerBaseInfoContent,
    { telemetryContentPlace, telemetryContentType }: Props,
    deps: Dependencies
) => {
    const preferredTracks = getEmptyPreferredTracks();
    const additionalParams = getPuidAndFrom(deps);

    let streams: Stream[] = [];

    if (trailer.streams) {
        streams = trailer.streams.reduce<Stream[]>((acc, stream) => {
            if (stream) {
                acc.push({
                    url: stream.uri,
                    audio: stream.streamMeta?.audioMetas.map((meta) => ({
                        label: meta?.language ?? '',
                        language: meta?.language ?? '',
                    })),
                    subtitles: [],
                });
            }

            return acc;
        }, []);
    }

    const source: Source[] = [
        {
            streams,
            userPreferences: {
                preferredTracks,
            },
            id: getPromoContentId(trailer),
            additionalParams: {
                ...additionalParams,
                from_block: telemetryContentPlace,
                stream_block: telemetryContentType,
            },
        },
    ];

    return source;
};
